<template>
  <div>
     <div class="p-4 max-w-main bg-vmain" style="min-height: calc(100vh - 62px);">
        <img @click="$router.push('/')" class="cursor-pointer" src="@/assets/default_main/logo1.svg" />
        <div class="text-center mt-4">
            <div class="mt-3">
                <div class="text-center">
                    <h2 class="text-2xl"><b>Bổ sung hồ sơ</b></h2>
                </div>
                <div class="mt-4">
                    <div class="mt-3">
                        <input autocomplete="off" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3" v-model="form.fullname" :class="{ 'border-input-success': form.fullname ? form.fullname.length > 0 ? true : false : false, 'border-input-error': click_check ? form.fullname.length < 1 ? true : false : false }" style="border: 1px solid #D6D9DB;" placeholder="Họ và tên" />
                    </div>
                    <div class="mt-3">
                        <input autocomplete="off" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3" v-model="form.identity_card_manual" :class="{ 'border-input-success': form.identity_card_manual ? form.identity_card_manual.length > 0 ? true : false : false, 'border-input-error': click_check ? form.identity_card_manual.length < 1 ? true : false : false }" style="border: 1px solid #D6D9DB;" placeholder="Số CMND/CCCD" />
                    </div>
                    <div class="mt-3">
                        <!-- <date-pick :format="'DD-MM-YYYY'" :placeholder="'Ngày cấp'" class="date-pick block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md" v-model="form.issued_on"></date-pick> -->
                        <!-- <date-pick :placeholder="'Ngày cấp'" /> -->
                        <!-- <date-picker :class="{ 'border-input-success': form.issued_on.length > 0 ? true : false, 'border-input-error': click_check ? form.issued_on.length < 1 ? true : false : false }" class="w-full h-14 rounded-md" :format="'DD-MM-YYYY'" v-model="form.issued_on" :placeholder="'Ngày cấp'" ></date-picker> -->
                        <date-picker :class="{ 'border-input-success': form.issued_on ? form.issued_on.length > 0 ? true : false : false, 'border-input-error': click_check ? form.issued_on.length < 1 ? true : false : false }" class="w-full h-14 rounded-md" :format="'DD-MM-YYYY'" v-model="form.issued_on" :placeholder="'Ngày cấp'" valueType="format"></date-picker>

                    </div>
                    <div class="mt-3">
                        <input autocomplete="off" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3" v-model="form.identity_card_place" :class="{ 'border-input-success': form.identity_card_place ? form.identity_card_place.length > 0 ? true : false : false, 'border-input-error': click_check ? form.identity_card_place.length < 1 ? true : false : false }" style="border: 1px solid #D6D9DB;" placeholder="Nơi cấp" />
                    </div>
                    <div class="mt-3">
                        <v-select v-model="form.gender" :reduce="(option) => option.id" :options="options" placeholder="Giới tính" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md" :class="{ 'border-input-success': form.gender != null ? true : false, 'border-input-error': click_check ? form.gender == null ? true : false : false }" />
                        
                        <!-- <input autocomplete="off" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3" v-model="form.gender" :class="{ 'border-input-success': form.gender ? true : false, 'border-input-error': click_check ? form.gender.length < 1 ? true : false : false }" style="border: 1px solid #D6D9DB;" placeholder="Giới tính" /> -->
                    </div>
                    <div class="mt-3">
                        <date-picker :class="{ 'border-input-success': form.dob ? form.dob.length > 0 ? true : false : false, 'border-input-error': click_check ? form.dob.length < 1 ? true : false : false }" class="w-full h-14 rounded-md" :format="'DD-MM-YYYY'" v-model="form.dob" :placeholder="'Ngày sinh'" valueType="format"></date-picker>
                        <!-- <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" required autocomplete="off" class="block w-full h-14 border-gray-400 focus:outline-none focus:border-transparent focus:ring-purple-600 rounded-md pl-3 pr-3" v-model="form.dob" :class="{ 'border-input-success': form.dob.length > 0 ? true : false, 'border-input-error': click_check ? form.dob.length < 1 ? true : false : false }" style="border: 1px solid #D6D9DB;" placeholder="Ngày sinh" /> -->
                    </div>
                </div>
            </div>
            <div class="mt-4 text-center">
                <button @click="saveInfo" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg"><b-spinner v-if="loading_otp" small type="grow"></b-spinner> Lưu lại thông tin </button>
            </div>

            <div class="border-gray-200 border-2 p-2 rounded-lg mt-3 w-48 m-auto">
                <button @click="$router.push('/')" class="font-bold" > Về trang chủ</button>
            </div>

            <b-modal hide-header hide-footer centered id="modal-tima">
                <tima-register />
            </b-modal>
        </div>
     </div>
  </div>
</template>

<script>
import {getPartner,getMoney,getLogo,getToken, getPhone} from '@/utils/auth'
import {sendFile,saveCustomer,getInforKyc, getAddressInfo} from '@/api/otp'
import TimaRegister from '../components/tima_register.vue'
//import DatePick from '@/components/datePick.vue'
//import DatePick from '../../components/datePick.vue'
// import DatePick from 'vue-date-pick';
// import 'vue-date-pick/dist/vueDatePick.css';
import { toDMY,toYMD,toYMDHMS,toYMD2  } from "@/filters/index"

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    props: ['not_show'],
    components: {DatePicker,TimaRegister },
    data() {
        return {
            form: {
                fullname: '',
                identity_card_manual: '',
                issued_on: '',
                identity_card_place: '',
                identity_card_date: '',
                gender: null,
                dob: '',
                location: '',
                address: '',
                hometown: '',
                date_of_expiry: ''
            },
            options: [
                { label: 'Nam', id: 1 },
                { label: 'Nữ', id: 0 },
                { label: 'Không xác định', id: 2 },
            ],
            click_check: false,
            isUpload: false,
            file1: '',
            file2: '',
            money: getMoney(),
            partner: getPartner(),
            logo: getLogo(),
            src1: '',
            src2: '',
            provinces: [],
            districts: [],
            disable: true,
            loading_otp: false,
        }
    },
    created() {
            this.fetchEkyc()
            this.fetchAddress()
            // var self  = this
            // setTimeout(() => {
            //         self.fetchDistrict()
            //     },500);
            //this.fetchDistrict()
            if(!getToken()){
                this.$router.push('/')
            }
        },
    methods: {
        saveInfo(){
            console.log(this.form.issued_on)
            console.log(this.form.dob)
            this.loading_otp = true
            this.form.issued_on =  toYMD2(this.form.issued_on);
            this.form.dob =  toYMD2(this.form.dob);
            this.form.identity_card_date = this.form.issued_on
            if(this.form.identity_card_manual != '' && this.form.identity_card_place != '' && this.form.dob != ''){
                saveCustomer(this.form).then(res => {
                    if(res.status == 200 || res.status == 0){
                        this.$router.push({
                            name: 'VStepThanks'
                        })
                    } else {
                        this.loading_otp = false
                        this.$bvModal._root.$children[0].modal = {
                            title: 'Có lỗi xảy ra',
                            content: res.message,
                            btnHome: false
                        }
                        this.$bvModal.show('modal-notify')
                    }
                })
            }else{
                this.$router.push({
                    name: 'VUpdateStepEnd'
                })
            }
        },
    },
}
</script>

<style>
.mx-input-wrapper {
    height: 56px;
}

.mx-input{
    height: 52px;
    font-size: 16px;
}
.mt-3 {
    margin-top: 2.5rem !important;
}

.mx-datepicker{
    width: 100%;
}

.border-input-success .mx-input{
    height: 52px;
    font-size: 16px;
    color: green;
}

.mx-icon-calendar {
    top: 45%;
}

.vs__dropdown-toggle {
    height: 100%;
}

.vs__search {
    color: #9AA0A5;
}

.vs--single .vs__selected {
    background-color: transparent;
    border-color: transparent;
    color: green;
}

/* .date-pick input {
    height: 56px;
    width: 100%;
    font-size: 16px;
    border: 1px solid rgb(214, 217, 219);
    border-radius: 6px;
    padding: 12px;
} */
</style>